import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { SupplierDecarbonization } from "../../../api";

export const supplierDecarbonizationKeys = {
  supplierDecarbonization: () => ["supplierDecarbonization"],
  supplierDecarbonizationChartData: () => ["supplierDecarbonizationChartData"],
  supplierReducedDecarbonizationChartData: () => ["supplierReducedDecarbonizationChartData"]
};

export function useInitialiseSupplierDecarbonization(id, config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(SupplierDecarbonization.initialiseSupplierDecarbonization, id), config);
}

export function useGetSupplierDecarbonization(id, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierDecarbonizationKeys.supplierDecarbonization(), id],
    () => callApi(SupplierDecarbonization.getSupplierDecarbonization, id), config);
}

export function useGetSupplierDecarbonizationChartData(id, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierDecarbonizationKeys.supplierDecarbonization(),
      ...supplierDecarbonizationKeys.supplierDecarbonizationChartData(), id],
    () => callApi(SupplierDecarbonization.getSupplierChartData, id), config);
}

export function useGetSupplierReducedDecarbonizationChartData(id, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierDecarbonizationKeys.supplierDecarbonization(),
      ...supplierDecarbonizationKeys.supplierReducedDecarbonizationChartData(), id],
    () => callApi(SupplierDecarbonization.getSupplierReducedChartData, id), config);
}

export function useUpdateSupplierEstimatedGrowth(id, config) {
  const { callApi } = useAuth();
  return useMutation(newData => callApi(SupplierDecarbonization.updateSupplierEstimatedGrowth, { id, newData }), config);
}

export function useExportSupplierDecarbonizationData(id, config) {
  const { callApi } = useAuth();
  return useMutation( year => callApi(SupplierDecarbonization.exportSupplierDecarbonizationData, { id, year }), config);
}